import { useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import { useTranslation } from "react-i18next";
import NotFoundComponent from "../NewDesign/NotFound/NotFoundComponent";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
import _ from "lodash";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import CONFIG from "../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import { getMyBookingRequest, getMyBookingRequestClear } from "../../redux/coaching/actions";
import API_LIST from "../../utils/apiList";
import { getProcureInfo, ProductCardPriceInfo, SessionKeys } from "../../utils/AppUtils";
import { useNavigate } from "react-router-dom";

const MyBookingsComponent = () => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const myBookingList = useSelector((state) => state.coaching.myBookingList);

  const [isLoading, setIsLoading] = useState(true);
  const [bookingList, setBookingList] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);

  useEffect(() => {
    dispatch(getMyBookingRequest({
      URL: CONFIG.API_URL_BROKER + API_LIST.ECOM_API.MY_COACHING_BOOKING_LIST,
      method: 'POST',
      isJSON: true,
      payload: {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
      }
    }))
  }, [dispatch])

  useEffect(() => {
    if (!_.isEmpty(myBookingList)) {
      if (myBookingList.status === "success") {
        const listData = myBookingList.payload?.data?.listing;
        let bkList = [];
        if (!_.isEmpty(listData.personal)) {
          bkList = [...bkList, ...formatCoachCardData(listData.personal, 'personal')]
        }

        if (!_.isEmpty(listData.service)) {
          bkList = [...bkList, ...formatCoachCardData(listData.service, 'service')]
        }
        console.log('bkList', bkList)
        setBookingList(bkList)
        setIsLoading(false)
      } else {
        setBookingList([])
        setIsLoading(false)
      }
      dispatch(getMyBookingRequestClear())
    }
  }, [myBookingList])

  const handleCoachDetailNavigate = (coach_id) => {
    let paramsReq = {
      coach_id: coach_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    navigate(`/coach/detail?c=${encodedUrl}`);
  };

  const handleCoachServiceDetailNavigate = (service_code) => {
    let paramsReq = {
      service_code: service_code,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    navigate(`/coach-service/detail?c=${encodedUrl}`);
  };

  const formatCoachCardData = (arrList, type) => {
    if (!_.isEmpty(arrList)) {
      let prodArr = [];
      for (let coach of arrList) {
        console.log("coach---", coach);
        let btnTitle =  t("Explore");
        let priceInfo = getProcureInfo(coach?.purchased_info);
        coach.priceInfo = priceInfo;
        // if (coach?.priceInfo?.isPurchased) {
        //   btnTitle = t("RequestForASession");
        // } else {
        //   btnTitle = t("Explore");
        // }

        prodArr.push({
          id: coach?.id,
          ecom_id: coach?.ecom_id ? coach?.ecom_id : coach?.wc_post_id,
          is_like: false,
          is_bookmark: false,
          is_wishlist: false,
          dbId: coach?.list_id,
          productType: "coach",
          productOrigin: coach?.origin,
          title: coach?.display_name,
          logoURL: coach?.provider?.provider_img
            ? coach?.provider?.provider_img
            : "",
          bannerURL: coach?.profile_image
            ? coach?.profile_image
            : "https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png",
          tagsArray: [],
          description: coach?.short_description,
          btnTitle: btnTitle,
          progress: coach?.crs_progress,
          showRating: true,
          ratings: coach?.ratings,
          skills: [], //coach?.user_skill,
          showIndustry: false,
          industry: !_.isEmpty(coach?.user_industry)
            ? coach?.user_industry[0]
            : "",
          showExperience: false,
          experience: coach?.experience,
          btnAction: () => {
            if (type === 'service') {
              handleCoachServiceDetailNavigate(coach?.product_sku);
            } else {
              handleCoachDetailNavigate(coach?.user_id);
            }
          },
          descAction: {},
          bannerAction: () => {
            if (type === 'service') {
              handleCoachServiceDetailNavigate(coach?.product_sku);
            } else {
              handleCoachDetailNavigate(coach?.user_id);
            }
           },
          footerLineComp: !_.isEmpty(priceInfo)
            ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
            : "",
          showHeader: true,
          showProviderIcon: false,
          showLikeMenu: false,
          showBody: true,
          showFooter: true,
          showProgress: false,
          cardClassName: "",
          rightBtnIcon: "/images/arrow-right.svg",
          leftBtnIcon: "",

          priceInfo,
          isBundle: false,
        });
      }
      return prodArr;
    }
  };

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <section className="bannersection manage-worksop">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col col-xl-12 col-lg-10 col-md-12">
              <div className="contsection">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mentor-title mb-0">{t("myBookings")}</h3>
                </div>
                <section className="cal-event-sec">
                  <div className="councoa d-flex justify-content-start my-3">
                    {isLoading ? (
                      <ShimmerScreen case="rect" width="15rem" height="1.5rem" />
                    ) : (
                      !_.isEmpty(bookingList) && (
                        <p>
                          {t("bookingListMsg").replace('{{count}}', bookingList?.length)}
                        </p>
                      )
                    )}
                  </div>
                  <div className="row coach-list g-xxl-5 g-4">
                    {!_.isEmpty(bookingList) ? (
                      bookingList?.map((item, i) => {
                        console.log("check000", item);
                        return (
                          <ProductCardComponent
                            {...item}
                            key={`course-${i + 1}`}
                            lastKey={false}
                          />
                        );
                      })
                    ) : (
                      <NotFoundComponent
                        width={200}
                        height={219}
                        showBtn={false}
                        showMsg={true}
                        msgLine={t("No Coach Found!")}
                      />
                    )}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default MyBookingsComponent;